import React from "react";
import classes from "./MoobiVault.module.scss";
import simulator from "../../assets/MoobiVaultImages/simulator.png";
import loandetails from "../../assets/MoobiVaultImages/loandetails.png";
import loanwithpaymentdetails from "../../assets/MoobiVaultImages/loanwithpaymentdetails.png";
import customerdatablock from "../../assets/MoobiVaultImages/customer data block 1.png";
import CaroselComponent from "./CaroselComponent";

function LoanManagment() {
  const images = [simulator, loandetails, loanwithpaymentdetails, customerdatablock].filter(Boolean);

  const TitlesLoan = [
    "eKYC",
    "User Management",
    "Automated Loan Origination",
    "Omni Channel Leads Generation",
    "Digital Onboarding",
    "Data Protection",
    "Credit Scoring & Decision Engine",
    "Electronic Contract Signature",
    "Integration with Credit Bureau, Banks and E-wallets"
  ];

  return (
    <>
      <div className={classes.LoanManagmentContainer}>
        <div className={classes.firstInfoPnPl}>
          <span className={classes.LoanManagmentTitle}>
            Loan Management<span className={classes.LoanManagmentTitleSecond}> System</span>
          </span>
          <p className={classes.LoanManagmentParagraph}>
            Streamline your lending process with our advanced fintech loan
            management system, featuring automation and smart credit decisioning
            to optimize efficiency, enhance security, and deliver a seamless
            experience for both lenders and borrowers.
          </p>
          {TitlesLoan.map((title, index) => (
            <div key={index} className={classes.bnPlPoints}>
              <div className={classes.dotTitlePositionsLoan}>
                <div className={classes.pointsStyle} />
                <span className={classes.bnplTitle}>{title}</span>
              </div>
            </div>
          ))}
        </div>
        <div className={classes.secondInfoPnPl}>
          <CaroselComponent images={images} length={4} />
        </div>
      </div>
    </>
  );
}

export default LoanManagment;
